class CartItmes extends HTMLElement {
    constructor() {
        super();

        this.cartitems = document.querySelector('cart-items');
        this.subTotal = document.querySelector('p[data-subtotal]');
        this.headerCartCounts = document.querySelector('[data-js-cart-count]');

        this.dadaNode = this.cartitems.querySelector('#cart-items');

        if(document.getElementById('keydata')){
            this.keyData = JSON.parse(document.getElementById('keydata').textContent);
            this.keyDataItems = this.keyData.items;
        }

        this.querySelectorAll('[data-action="updateQty"]').forEach((updateButton) =>
            updateButton.addEventListener('click', this.updateLineItem.bind(this))
        );
        this.querySelectorAll('[data-action="removeEmbroidery"]').forEach((remEmbBtn) =>
            remEmbBtn.addEventListener('click', this.updateLineItem.bind(this))
        );
        this.querySelectorAll('[data-action="remove"]').forEach((removeBtn) =>
            removeBtn.addEventListener('click', this.updateLineItem.bind(this))
        );
        if(window.protectioncharges){
            this.querySelectorAll('[data-protectiontoggle]').forEach((protectionToggleBtn) =>
                protectionToggleBtn.addEventListener('change', this.protectionSwitch.bind(this))
            );
            if(this.querySelector('[data-action="dummycheckout"]')){
                this.querySelector('[data-action="dummycheckout"]').addEventListener('click', this.dummyCheckoutBtnCheck.bind(this));
            }
        }
        if(window.giftboxAddOn) {
            this.querySelectorAll('#toggleGiftBox').forEach((input) =>
                input.addEventListener('change', this.giftBoxAddonSwitch.bind(this))
            );
            this.querySelectorAll('.giftbox_image').forEach((elem) =>
                elem.addEventListener('click', this.giftBoxAddonSwitch.bind(this))
            );
        }


        // remove if embroidery v1 variant found in cart
        const olderVersionEmbroidery = ['42353300734167','42353300766935','42353300799703'];
        this.querySelectorAll('.cart__item').forEach(function (item){
            var itemVarId = item.dataset.embvarid;
            var hasEmbroidery = item.querySelector('[data-action="removeEmbroidery"]');
            if(itemVarId && hasEmbroidery){
              if(window.cartiteminventory[itemVarId] == 'false'){
                item.querySelector('[data-action="remove"]').click();
              }
            }
            if(olderVersionEmbroidery.includes(itemVarId)){
                document.querySelector('.cart__embroidery-warning').style.display = 'flex';
            }
        });

        /**
         * Attaches a click event listener to the 'checkout' button in the cart footer.
         * When the button is clicked, it checks if the user is on a mobile device and if the current page is the cart page.
         * If both conditions are met, it updates the browser history state with the current page URL.
         * This is done to remove the overlay from cart page, navigating back to the cart page after checkout on mobile devices.
         */
        this.querySelector('.cart__footer-actions [name="checkout"]').addEventListener('click', (e) => {
            const userAgent = navigator.userAgent;
            const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
            const isCartPage = window.location.pathname.includes('/cart');

            this.dadaNode.classList.add('updating');

            if (isMobileDevice && isCartPage) {
                if (!history.state || history.state !== null) {
                    const updatedState = { _page: true };
                    history.replaceState(updatedState, null, window.location.href);
                }
            }
        });

        this.emrboideryCorrectRefreshBtn = document.querySelector('[data-embroidery="refresh"]');
        this.emrboideryCorrectRefreshBtn.addEventListener('click', this.emrboideryCorrectRefresh.bind(this));

    }

    emrboideryCorrectRefresh(test){
        window.correctEmbroidery();
    }

    updateLineItem(event){
        this.dadaNode.classList.add('updating');
        var parentElem = event.target.closest('.cart__item'); // bad hack, event.target retrun inner elements
        var parentProdRefKey = parentElem.dataset.refKey;
        var parentProdKey = parentElem.dataset.cartKey;
        var embroideryProdKeyList = [];
        var childIdenticalIconsVarId_x = parentElem.dataset.identicalembroideryiconsvarid.split(":");
        var childIdenticalIconsVarId = childIdenticalIconsVarId_x[0] || null;
        var childIdenticalIconsNum = parseInt(childIdenticalIconsVarId_x[1]) || null;
        let identicalIconKey = null;

        for(var i=0; i<this.keyDataItems.length; i++){
            var t = this.keyDataItems[i];
            if(t.parentkey == parentProdRefKey){
                embroideryProdKeyList.push(t.key);
                console.log(embroideryProdKeyList)
            }
            // else{
            //     console.log("parent key and producrefkey not same");
            // }
            if(t.parentkey){
                var splitKey_varid = t.key.split(':')[0];
                console.log(splitKey_varid);
                if(splitKey_varid == childIdenticalIconsVarId){
                    identicalIconKey = t.key;
                }
            }
        }
        var actionType = event.target.closest('[data-action');
        if(actionType.dataset.action == "updateQty"){
            var parentProdQty = actionType.dataset.qty,
                embroideryProdQty = actionType.dataset.qty;
            // var ajaxData = JSON.stringify({ id: parentProdKey, quantity: qty });
        }
        else if(actionType.dataset.action == "remove"){
            var parentProdQty = 0,
                embroideryProdQty = 0;
            // var ajaxData = JSON.stringify({ id: parentProdKey, quantity: qty, properties: {'': ''} })
        }
        else if(actionType.dataset.action == "removeEmbroidery"){
            var parentElem = event.target.closest('[data-action="removeEmbroidery"]');
            var parentProdQty = parentElem.dataset.qty,
                embroideryProdQty = 0;
            var ajaxData = JSON.stringify({ id: parentProdKey, quantity:parentProdQty, properties: {'': ''} })
        }


        /*console.log(`embroideryProdKeyList: ${embroideryProdKeyList},
        parentProdKey: ${parentProdKey},
        parentProdQty: ${parentProdQty},
        embroideryProdKeyList: ${embroideryProdKeyList},
        embroideryProdQty: ${embroideryProdQty},
        identicalIconKey: ${identicalIconKey},
        childIdenticalIconsNum: ${childIdenticalIconsNum},
        ajaxData: ${ajaxData},
        actionType.dataset.action: ${actionType.dataset.action}`);*/

        if(embroideryProdKeyList){
            this.updateLineItemCall(parentProdKey, parentProdQty, embroideryProdKeyList, embroideryProdQty, identicalIconKey, childIdenticalIconsNum, ajaxData, actionType.dataset.action, parentElem);
        } else {
            this.updateLineItemCall(parentProdKey, parentProdQty, null, embroideryProdQty, null, null, ajaxData, actionType.dataset.action, parentElem);
        }
    }

    renderCart(content){
        var $this = this;
        $this.subTotal.innerHTML = Shopify.formatMoney(content.original_total_price, Shopify.money_format);
        if($this.headerCartCounts) {
            $this.headerCartCounts.innerHTML = content.item_count;
        }

        var hasOnlyInsurace = false;

        if(content.items && content.items.length == 1){
            if(content.items[0].product_type == "Insurance"){
                hasOnlyInsurace = true;
            }
        }
        document.querySelector('[data-js-cart-count]').textContent = content.item_count;
        if(hasOnlyInsurace){
            fetch('/cart/clear.js', {
                body: '',
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
              }).then(function (cart) {
                return cart.json();
              }).then(function (r) {

                if($this.headerCartCounts){
                    $this.headerCartCounts.innerHTML = r.item_count;
                }

                fetch('/cart?view=ajax&timestamp=' + Date.now(), {
                    credentials: 'same-origin',
                    method: 'GET'
                }).then(function (content) {
                    $this.dadaNode.classList.remove('updating');
                    content.text().then(function (html) {
                        $this.cartitems.innerHTML = html;
                    });
                });
              })
        }else{
            fetch('/cart?view=ajax&timestamp=' + Date.now(), {
                credentials: 'same-origin',
                method: 'GET'
            }).then(function (content) {
                $this.dadaNode.classList.remove('updating');
                content.text().then(function (html) {
                    $this.cartitems.innerHTML = html;
                });
            });
        }

        if(window.protectioncharges) {
            this.popupPMO();
        }

       
    }

    protectionSwitch(togglelem){
        var parentNode = togglelem.target.closest('.quick-cart__protection');
        parentNode.classList.add('updating');
        if (togglelem.target.checked) {
            parentNode.dataset.protectionactive = 'true';
            var _insurance = true;
        } else {
            parentNode.dataset.protectionactive = 'false';
            var _insurance = false;
        }

        fetch('/cart/update.js', {
            body: JSON.stringify({
                attributes: {
                    '_insurance': _insurance
                }
                }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
        }).then(function (cart) {
            parentNode.classList.remove('updating');
        })
    }
    // Gifbox Add-on cart page
    giftBoxAddonSwitch(){
        var giftBoxElem = document.querySelector('[data-giftbox]');
        var parentNode = document.querySelector('cart-items #cart-items');
        var inputCheckbox = document.querySelector('#toggleGiftBox');
        var productId = inputCheckbox.getAttribute('data-variant-id');
        var $this = this;
        parentNode.classList.add('updating');

        fetch('/cart/update.js', {
            body: JSON.stringify({}),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
        }).then(function (cart) {

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header00
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: 1
                })
            })
            // Handle the response from the server after updating the cart
            .then(response => {
                if (response.status == 200) {
                    inputCheckbox.checked = false;
                    giftBoxElem.classList.remove('active');
                    parentNode.classList.remove('updating');
                } else {
                    parentNode.classList.remove('updating');
                    console.error('Request returned an error', response)
                }
                return response.json();
            }).then((function(t){
                $this.renderCart(t);
            }))
            .catch((error) => {
                parentNode.classList.remove('updating');
                console.error('Error:', error);
            });


        });
    }

    dummyCheckoutBtnCheck(elem){
        // if ebroidery inconsistency found
        if (elem.target.dataset.embroideryBlock == 'true') {
            let errorElement = document.querySelector('[data-error="embroidery"]');
            errorElement.classList.add('animate__shake');

            setTimeout(function() {
                errorElement.classList.remove('animate__shake');
            }, 1000);
            return;
        } else {
            var checkoutbtn = document.querySelector('.cart__footer-actions [name="checkout"]');
            checkoutbtn.click();
        }

        // this.dadaNode.classList.add('updating');
        // var protectionData = document.querySelector('#cartProtectionToggle');
        // if(protectionData.checked){
        //     protectionCheck(true);
        // } else {
        //     protectionCheck(false);
        // }
    }

    formToJSON(elements, qty) {
        return [].reduce.call(elements, function (data, element) {
            data[element] = qty;
            return data;
        }, {});
    }

    updateLineItemCall(parentKey, parentQty, embroideryKey, embroideryQty, identicalIconKey, times, data, type, thisElem){
        var $this = this;
        if(type == "updateQty" || type == "remove"){

            if(type == "updateQty"){
                fetch('/cart/change.js', {
                    body: JSON.stringify({ id: parentKey, quantity: parentQty }),
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                    }
                })
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const parsedState = JSON.parse(state);

                    if(parsedState.message){
                        let selectedElement = thisElem.querySelector('.cart__item-quantity');
                        let errorElement = selectedElement.querySelector('.cart__item-error');
                        if (!errorElement) {
                            const errorMsg = `<div class="cart__item-error">${parsedState.message}</div>`;
                            selectedElement.insertAdjacentHTML('beforeend', errorMsg);
                        }
                        this.dadaNode.classList.remove('updating');
                        // $this.renderCart(parsedState);
                    } else {

                        let updateData = {
                            updates: embroideryKey.reduce((acc, key) => {
                                acc[key] = (identicalIconKey && key === identicalIconKey) ? embroideryQty * times : embroideryQty;
                                return acc;
                            }, {}),
                            // }, {[parentKey]: parentQty})
                        }
                        //console.log(updateData)

                        fetch(window.Shopify.routes.root + 'cart/update.js', {
                            body: JSON.stringify(updateData),
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                            }
                        }).then(function (cart) {
                            cart.json().then(function (content) {
                                if(content.status == 422){
                                    console.log(content.description);
                                    $this.renderCart(content);
                                    return;
                                }

                                // Check for PMO status
                                const cartAttributeInsurancePrev = content.attributes['_insurance'];
                                let cartAttributeInsurance = content.attributes['_insurance'],
                                    hasOnlyExcludeItems = true

                                content.items.forEach((item) => {
                                    var productTypeHandlize = item.product_type.trim().toLowerCase().replace(/\s/g, "");
                                    if(productTypeHandlize.indexOf('giftcard') !== -1){

                                    } else if(productTypeHandlize.indexOf('insurance') !== -1){

                                    } else{
                                        hasOnlyExcludeItems = false
                                    }
                                })

                                if(hasOnlyExcludeItems){
                                    cartAttributeInsurance = 'false'
                                }

                                if(cartAttributeInsurancePrev != cartAttributeInsurance){
                                    fetch('/cart/update.js', {
                                        body: JSON.stringify({
                                            attributes: {
                                            '_insurance': cartAttributeInsurance
                                            }
                                        }),
                                        credentials: 'same-origin',
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                        }
                                    }).then(function (cart) {
                                        return cart.json();
                                    }).then((function(t){
                                        $this.renderCart(t);
                                    }))
                                }
                                else {
                                    $this.renderCart(content);
                                }
                            });
                        });
                    }
                });
            } else {
                let updateData = {
                    updates: embroideryKey.reduce((acc, key) => {
                        acc[key] = (identicalIconKey && key === identicalIconKey) ? embroideryQty * times : embroideryQty;
                        return acc;
                    }, {[parentKey]: parentQty})
                }
                // console.log(updateData); return;

                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    body: JSON.stringify(updateData),
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                    }
                }).then(function (cart) {
                    cart.json().then(function (content) {
                        if(content.status == 422){
                            console.log(content.description);
                            $this.renderCart(content);
                            return;
                        }

                        // Check for PMO status
                        const cartAttributeInsurancePrev = content.attributes['_insurance'];
                        let cartAttributeInsurance = content.attributes['_insurance'],
                            hasOnlyExcludeItems = true

                        content.items.forEach((item) => {
                            var productTypeHandlize = item.product_type.trim().toLowerCase().replace(/\s/g, "");
                            if(productTypeHandlize.indexOf('giftcard') !== -1){

                            } else if(productTypeHandlize.indexOf('insurance') !== -1){

                            } else{
                                hasOnlyExcludeItems = false
                            }
                        })

                        if(hasOnlyExcludeItems){
                            cartAttributeInsurance = 'false'
                        }

                        if(cartAttributeInsurancePrev != cartAttributeInsurance){
                            fetch('/cart/update.js', {
                                body: JSON.stringify({
                                    attributes: {
                                    '_insurance': cartAttributeInsurance
                                    }
                                }),
                                credentials: 'same-origin',
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                }
                            }).then(function (cart) {
                                return cart.json();
                            }).then((function(t){
                                $this.renderCart(t);
                            }))
                        }
                        else {
                            $this.renderCart(content);
                        }
                    });
                });
            }
        } else {
            // this.dadaNode.classList.add('updating');
            // var $this = this;
            // var cartItems = this.cartitems;
            // var subTotal = this.subTotal;

            // main/parent product update
            fetch(window.Shopify.routes.root + 'cart/change.js', {
                body: data,
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
            }).then(function (cart) {
                cart.json().then(function (content) {

                    if(content.status == 422){
                        console.log(content.description);
                        $this.renderCart(content);
                        return;
                    }

                    // remove child embroidery product
                    let updateData = {
                        updates: embroideryKey.reduce((acc, key) => {
                            acc[key] = embroideryQty;
                            console.log(acc);
                            return acc;
                        }, {}),
                        // }, {[parentKey]: parentQty})
                    }
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        body: JSON.stringify(updateData),
                        credentials: 'same-origin',
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                        }
                    }).then(function (cart) {
                        cart.json().then(function (content) {
                            if(content.status == 422){
                                console.log(content.description);
                                $this.renderCart(content);
                                return;
                            }

                            $this.renderCart(content);
                        });
                    });

                    /*
                    // commented by Inscoder HG | code optimized

                    if(embroideryKey.length){
                        let embroideryQty = 0;
                        if(type == "updateQty"){
                            content.items.forEach(function(item){
                                if(item.key == parentKey){
                                    embroideryQty = item.quantity;
                                }
                            });
                        }

                        fetch(window.Shopify.routes.root + 'cart/change.js', {
                            body: JSON.stringify({ id: embroideryKey[0], quantity: embroideryQty}),
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                            }
                        }).then(function (cart) {
                            cart.json().then(function (content) {
                                if(embroideryKey.length > 1){
                                    fetch(window.Shopify.routes.root + 'cart/change.js', {
                                        body: JSON.stringify({ id: embroideryKey[1], quantity: embroideryQty}),
                                        credentials: 'same-origin',
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                        }
                                    }).then(function (cart) {
                                        cart.json().then(function (content) {
                                            fetch('/cart/update.js', {
                                                body: JSON.stringify({
                                                    attributes: {
                                                    '_insurance': cartAttributeInsurance
                                                    }
                                                }),
                                                credentials: 'same-origin',
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                                }
                                            }).then(function (cart) {
                                                return cart.json();
                                            }).then((function(t){
                                                $this.renderCart(t);
                                            }))
                                            // $this.renderCart(content);
                                        });
                                    });
                                } else{
                                    fetch('/cart/update.js', {
                                        body: JSON.stringify({
                                            attributes: {
                                            '_insurance': cartAttributeInsurance
                                            }
                                        }),
                                        credentials: 'same-origin',
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                                        }
                                    }).then(function (cart) {
                                        return cart.json();
                                    }).then((function(t){
                                        $this.renderCart(t);
                                    }))
                                    // $this.renderCart(content);
                                }
                            });
                            // cart.json().then(function (content) {
                            //     content.items.forEach(function(item){

                            //     });
                            // });
                        });
                    } else {

                        fetch('/cart/update.js', {
                            body: JSON.stringify({
                                attributes: {
                                '_insurance': cartAttributeInsurance
                                }
                            }),
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                            }
                        }).then(function (cart) {
                            return cart.json();
                        }).then((function(t){
                            $this.renderCart(t);
                        }))
                    }
                    */
                });
            });
        }
    }

    popupPMO() {
        let checkElementExistence = setInterval(function() {
            const modalOpenButton = document.querySelectorAll('[data-pmo-popup]');
            if(modalOpenButton) {
                clearInterval(checkElementExistence);
                const body = document.querySelector('body');
                const modal = document.querySelector('.modal-pmo');
                const modalCloseButton = document.querySelector('[data-cta-close]');
                const pmoButtonRemove = document.querySelector('[data-pmo-remove]');
                const addToCart = document.querySelector('[data-pmo-add-to-cart]');
                const checkboxPMO =  document.querySelectorAll('.quick-cart__protection-action-btn label');
                const isPMOinCart = document.getElementById('cartProtectionToggle');
                const isPMOinDrawer = document.getElementById('minicartProtectionToggle');
                const isCartPage = window.location.pathname.includes('/cart');
                const addToCartText = "Add Purchase Protection"
                const addToCartTextAdded = "Purchase Protection Added!"

                const modalReset = () => {
                    modal.classList.remove('show');
                    body.classList.remove('overflow-hidden');
                }

                const updateCheckboxPMO = (isEnabled) => {
                    checkboxPMO.forEach((checkbox) => {
                        const checkboxStatus = checkbox.previousElementSibling.checked;
                        if (isCartPage && isEnabled && !checkboxStatus) {
                        checkbox.click();
                        }else if(isCartPage && !isEnabled&& checkboxStatus) {
                        checkbox.click();
                        }else if(!isCartPage) {
                        checkbox.click()
                        }
                    });
                }
                modalOpenButton.forEach((button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const modalTarget = button.getAttribute('data-popup-target');
                        body.classList.add('overflow-hidden');
                        modal.classList.add('show');
                        addToCart.removeAttribute('disabled');

                        // check the pmo checkboxes
                        //checkboxPMO[0] = cart drawer
                        //checkboxPMO[1] = cart page
                        if(isCartPage){
                        const checkbox = checkboxPMO[(( modalTarget == 'cart')?0:1)];
                        const checkboxCartStatus = checkbox.previousElementSibling.checked;

                        // trigger checkbox cartdrawer
                        if(isPMOinCart.checked && !checkboxCartStatus) {
                            checkboxPMO[0].click();
                        }else if(!isPMOinCart.checked && checkboxCartStatus){
                            checkboxPMO[0].click();
                        }

                        const checkBoxes =  checkboxPMO[(( modalTarget == 'drawer')?0:1)];
                        const checkBoxesStatus = checkBoxes.previousElementSibling.checked;
                        if(checkBoxesStatus) {
                            addToCart.setAttribute('disabled', true);
                            addToCart.textContent = addToCartTextAdded;
                        }else {
                            addToCart.removeAttribute('disabled');
                            addToCart.textContent = addToCartText;
                        }
                        }
                    });
                });
                modalCloseButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    modalReset();
                });
                addToCart.addEventListener('click', (e) => {
                    e.preventDefault();
                    modalReset();
                    updateCheckboxPMO(true);
                });
                pmoButtonRemove.addEventListener('click', (e) => {
                    e.preventDefault();
                    modalReset();
                    updateCheckboxPMO(false);
                });
            }
        }, 1000);
    }

}
customElements.define('cart-items', CartItmes);

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var Shopify = Shopify || {};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};